import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface MonitoringUIState {
  activeTab: number;
  autoRefresh: boolean;
}

const initialState: MonitoringUIState = {
  activeTab: 0,
  autoRefresh: true,
};

const monitoringSlice = createSlice({
  name: 'monitoringUI',
  initialState,
  reducers: {
    setMonitoringTab(state, action: PayloadAction<number>) {
      state.activeTab = action.payload;
    },
    toggleAutoRefresh(state) {
      state.autoRefresh = !state.autoRefresh;
    },
  },
});

export const { setMonitoringTab, toggleAutoRefresh } = monitoringSlice.actions;
export default monitoringSlice.reducer;
